'use strict';

function LoanApplicationRetrieveBank() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._classes = {
    connectAnimation: '.js--connect-animation'
  };

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._$node = $(this.node);

    // Elements
    this._$connectAnimation = this._$node.find(this._classes.connectAnimation);

    // Animation Elements
    this._$connectingSpinnerWrapper = this._$connectAnimation.find('.progress-clock__indicator');
    this._$connectingSpinner1 = this._$connectingSpinnerWrapper.find('.progress-clock__circle:first-child');
    this._$connectingSpinner2 = this._$connectingSpinnerWrapper.find('.progress-clock__circle:last-child');
    this._$connectingSteps = this._$connectAnimation.find('.progress-clock__steps');

    this.analytics.forcePushEvent('virtual-page-view');
    this.analytics.forcePushEvent('mogo-money-status', null, this);

    this._removeProgressLoader();
    this._initAnimation();

    this._loanApplications[0].verifyBankAccount({
      success: this._onVerifyBankSuccess.bind(this),
      failure: this._onVerifyBankFailure.bind(this)
    });
  };

  this.destroy = function () {
    this._super();
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };

  this._initAnimation = function () {
    this._$connectingSpinnerWrapper.addClass('progress-clock__circle-wrapper');
    this._$connectingSpinner1.addClass('progress-clock__circle-1');
    this._$connectingSpinner2.addClass('progress-clock__circle-2');
    this._$connectingSteps.addClass('progress-clock__steps-anim');
  };

  this._onVerifyBankSuccess = function (data, response) {
    $('#LoanApplicationTray').mogo()._loanAppSetStepComplete();
    // there should be an ABS status when it hits this callback
    if (this._loanApplications[0].getAbsStatus() !== 'auto_success') {
      this._history.goToUrl(this.paths.loans.application_flow_complete_error); // Complete with errors
    } else {
      this._history.goToUrl(this.paths.loans.application_flow_complete); // Complete page
    }
  };

  this._onVerifyBankFailure = function (data, response) {
    // Auto timeout
    if (data.errors[0].code === 408) {
      this._history.goToUrl(this.paths.loans.application_status);
    } else if (this.isGeneralConnectionIssue(data, response)) {
      if (this._errorInitialized === false) {
        this._errorInitialized = true;

        this.invokeConnectionIssuePage(request, {
          productLabel: 'Money'
        }, null, {
          retryRequest: true
        });
      }
    } else {
      // Everything else
      if (data.errors) {
        this.analytics.forcePushEvent('generic-api-response-error', {
          event: ['LoanApplicationABSVerifyResponse'],
          Code: [data.errors[0].code],
          Key: [data.errors[0].key],
          Msg: [data.errors[0].msg],
          Property: [data.errors[0].property]
        });
      }

      // Send Error analytics to be tracked
      $('#Notification').mogo().create({
        type: 'custom',
        msg: '<h2><span class="icon--warning"/>Oh no...</h2>' + "We're having some technical issues. Please try again. If the problem persists, try us again in a few minutes.",
        customClass: 'loan-application-notification--warning',
        notificationDescriber: 'error'
      });

      $.each(data.errors, function (index, element) {
        console.warn('key: ' + element.key + ', ' + ('msg: ' + element.msg));
      });
    }
  };
}